import {Auth} from 'aws-amplify';

class Amazon {
    load = (appId) => {
        const domain = window.location.href.toString().split(window.location.host)[1];
        return new Promise((resolve) => {
            window.onAmazonLoginReady = () => {
                amazon.Login.setClientId(appId);
                amazon.Login.setSiteDomain('randa.deletestaging.com');
            };

            (function(d) {
                const a = d.createElement('script');
                a.type = 'text/javascript';
                a.async = true;
                a.id = 'amazon-login-sdk';
                a.src = 'https://assets.loginwithamazon.com/sdk/na/login1.js';
                a.onload = () => {
                    resolve();
                };
                d.body.appendChild(a);
            })(document);
        });
    };

    signIn() {
        const options = { scope : 'profile' };

        return new Promise((resolve, reject) => {
            amazon.Login.authorize(options, (response) => {
                if (response.error) {
                    reject(response.error);
                }
                const accessToken = response['access_token'];
                const expiresIn = response['expires_in'];
                const authObject = {
                    accessToken,
                    expiresIn
                };
                resolve(authObject);
            });
        });
    }

    getUserObject() {
        return new Promise((resolve) => {
            amazon.Login.retrieveProfile((response) => {
                const id = response.profile.CustomerId;
                const username = response.profile.Name.replace(/\s/g, '');
                const email = response.profile.PrimaryEmail;
                const user = {
                    id,
                    username,
                    email
                };
                resolve(user);
            });
        });
    }
}

const instance = new Amazon();

export default instance;
